import React from 'react'
import { manufacturerToClass } from '@cbgms/components/src/utils/vehicle'
import { Icon, SxProps } from '@mui/material'

export interface IVehicleDetailsProps {
  manufacturer?: string
  imageSize?: 'tiny' | 'normal' | 'large' | 'massive'
  sx?: SxProps
}

export const VehicleMakeImage: React.FC<IVehicleDetailsProps> = ({ manufacturer, imageSize, sx }) => {
  return <Icon className={`icon vehicle brand ${imageSize ?? ''} ${manufacturerToClass(manufacturer)}`} sx={sx} data-testid='brand-icon' />
}

export default VehicleMakeImage
